import React from 'react';
import { white, business_800 } from '@fiverr-private/sass/helpers';
import { translate } from '@fiverr-private/i18n-react';
import { CheckStarSolidIcon } from '@fiverr-private/icons';
import Badge from '../Badge';
import { BadgeProps } from '../../types';

const PRO_LABEL = 'Pro';

const ProBadge = ({
  showTooltip = true,
  tooltipPosition = 'top',
  dataTestId,
  appendTooltipToBody,
  disableTooltipFlip,
}: BadgeProps) => (
  <Badge
    showTooltip={showTooltip}
    color={white}
    backgroundColor={business_800}
    tooltipContent={translate('badges.pro_badge.tooltip')}
    tooltipPosition={tooltipPosition}
    dataTestId={dataTestId}
    appendTooltipToBody={appendTooltipToBody}
    disableTooltipFlip={disableTooltipFlip}
  >
    <CheckStarSolidIcon size={12} color="currentColor" />
    <p>{PRO_LABEL}</p>
  </Badge>
);

ProBadge.displayName = 'ProBadge';

export default ProBadge;
